import React from 'react'
import cn from 'classnames'

import PanelGroup from 'components/PaneGroup'
import RightSidebar from 'components/App/DesktopView/Layout/RightSidebar'
import MainCell from 'components/App/DesktopView/Layout/MainCell'
import HelplyCopilotPanel from 'components/App/DesktopView/Layout/HelplyCopilotPanel'
import withPanelWidthManager from 'components/App/DesktopView/Layout/withPanelWidthManager'
import TicketList from 'subapps/ticketing/components/TicketList'
import { emptyObj } from 'util/objects'

import RightSidebarToggler from '../../RightSidebar/Toggler'
import useRightSidebar from '../../RightSidebar/useRightSidebar'
import {
  applyCopilotPanelWidth,
  keepStoredSidebarWidth,
} from '../copilotPanelWidth'

import styles from '../styles.css'
import { styles as emotionStyles } from './styles'

import { DEFAULT_WIDTHS, DEFAULT_BREAKPOINTS, STORAGE_KEY } from './defaults'

class ClassicView extends React.PureComponent {
  // Length has to match panes count
  componentWrappers = [
    null,
    React.forwardRef((props, ref) => {
      const { isRightSidebarCollapsed } = this.props
      const { onTransitionEnd, finalStyle } = useRightSidebar({
        isRightSidebarCollapsed,
        style: props.style,
      })
      return (
        <div
          {...props}
          ref={ref}
          onTransitionEnd={onTransitionEnd}
          style={finalStyle}
          className={cn(
            props.className,
            styles.rightSidebarWrapper,
            'hidden-in-print'
          )}
        />
      )
    }),
  ]

  render() {
    const {
      isNewConversation,
      isNewEmail,
      isHelplyCopilotOpen,
      ticketId,
      panelWidths = [],
      panelUpdateCallback,
    } = this.props

    const shouldDisplayList = !isNewEmail && !isNewConversation && !ticketId
    const isCopilotDocked =
      isHelplyCopilotOpen && !!ticketId && ticketId !== 'new'
    const effectivePanelWidths = isCopilotDocked
      ? applyCopilotPanelWidth(panelWidths)
      : panelWidths
    // Only guard persistence when the sidebar width is actually forced —
    // an already-wide-enough sidebar stays freely resizable and persistable.
    const isSidebarWidthForced = effectivePanelWidths !== panelWidths
    const handlePanelUpdate = isSidebarWidthForced
      ? updatedWidths =>
          panelUpdateCallback(
            keepStoredSidebarWidth(updatedWidths, panelWidths)
          )
      : panelUpdateCallback

    return (
      <React.Fragment>
        {shouldDisplayList ? (
          <TicketList channelType="mailbox" />
        ) : (
          <React.Fragment>
            <RightSidebarToggler />
            <PanelGroup
              css={emotionStyles.paneGroup}
              spacing={0}
              panelWidths={effectivePanelWidths}
              onUpdate={handlePanelUpdate}
              ComponentWrappers={this.componentWrappers}
              breakpoints={DEFAULT_BREAKPOINTS}
              className="three-column-view"
            >
              <MainCell />
              <RightSidebar
                panelWidth={(effectivePanelWidths[2] || emptyObj).size}
              />
            </PanelGroup>
          </React.Fragment>
        )}
        {/* Always mounted (a stable sibling of the list/ticket branch above) so
            switching tickets — which in classic view routes through the list —
            doesn't unmount + reload its iframe and force a re-auth. */}
        <HelplyCopilotPanel />
      </React.Fragment>
    )
  }
}

export default withPanelWidthManager(DEFAULT_WIDTHS, STORAGE_KEY)(ClassicView)
